module.exports = __webpack_public_path__ + "media/blue_bg.556e30d2.mp4";